<template>
    <div class="prod_name_detail">
      <div class="people_purchased">{{details.productName}}</div>
      <div class="price_value">
        <h5 class="final_amount">&#8377;​{{FinalAmt}}</h5>
        <h5 class="greyTxt">&#8377;​{{details.mrp}}</h5>
      </div>
     
      <router-link
        :to="{path: '/product-comment/'+ details.saleReferenceID }"
        tag="h6"
        class="comment_route"
        v-if="details.commentCount > 0"
      >{{details.commentCount}} {{$t('comments')}}</router-link>
      <router-link
        :to="{path: '/product-comment/'+ details.saleReferenceID }"
        tag="h6"
        class="comment_route"
        v-else
      >{{$t('doComment')}}</router-link>
       <h5
        class="extra_discount"
        v-if="details.onlineDiscount > 0 && isSnackbar"
      >{{$t('onlineDiscountOnProd',{cost:details.onlineDiscount})}}</h5>
    </div>
</template>

<script>
export default {
  name: "PrdtName",
  props: {
    dataName: {
      required: true,
      type: Object
    },
    showDiscountSnackbar: {
      type: Boolean
    },
    finalAmount: {
      required: true
    },
    cutAmountStyle: {
      required: true
    }
  },
  data() {
    return {
      details: {},
      isSnackbar: false,
      FinalAmt: ""
    };
  },
  watch: {
    dataName() {
      this.details = this.dataName;
    },
    showDiscountSnackbar() {
      this.isSnackbar = this.showDiscountSnackbar;
    },
    finalAmount() {
      this.FinalAmt = this.finalAmount;
    }
  },
  mounted() {
    this.details = this.dataName;
    this.FinalAmt = this.finalAmount;
    this.isSnackbar = this.showDiscountSnackbar;
  }
};
</script>
    